import * as React from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import { State } from "../Store";
import { WidgetContext } from "../Context";
import FeedbackForm from "./FeedbackForm";

interface AppConnectedProps { }

const App: React.FunctionComponent<AppConnectedProps> = () => {
  const { localization } = useSelector<State, State>(store => store);
  const appContext = React.useContext(WidgetContext);
  const { config } = appContext;

  return localization &&
    localization.messages &&
    Object.keys(localization.messages).length ? (
    <IntlProvider {...localization} locale={localization.locale + "-ca"}>
      <FeedbackForm lang={config.lang} url={config.url} localizationUrl={config.localizationUrl} brand = {config.brand} brandStyle = {config.brandStyle} token={config.token}  supportEmail={config.supportEmail}  supportPhone={config.supportPhone}  supportTTYPhone={config.supportTTYPhone} siteKey={config.siteKey} recaptchaValidationUrl={config.recaptchaValidationUrl} recaptchaClientId={config.recaptchaClientId} recaptchaText={config.recaptchaText} isDebugMode={config.isDebugMode} isRecaptchaOn={config.isRecaptchaOn} isProd={config.isProd}></FeedbackForm>
    </IntlProvider>
  ) : null;
};

App.displayName = "accessibility-feedback";

export default App;
